import styled from 'styled-components'

export const LayoutThree = styled.div`
  display: grid;
  grid-template-areas: 'leftside main rightside';
  grid-template-columns: minmax(250px, 3fr) minmax(800px, 12fr) minmax(
      90px,
      2.5fr
    );
  column-gap: 30px;
  row-gap: 25px;
  grid-template-rows: auto;
  width: 1100px;
  margin: 25px auto;

  overflow-y: visible;
  overflow-x: visible;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    padding: 0;
    margin: 0 0 60px 0;
    width: 100%;
  }
`
export const LayoutTwo = styled.div`
  display: grid;
  grid-template-areas: 'leftside main';
  grid-template-columns: minmax(350px, 3fr) minmax(700px, 12fr);
  column-gap: 20px;
  row-gap: 25px;
  grid-template-rows: auto;
  width: 1100px;
  margin: 25px auto;
  padding-bottom: 60px;

  overflow-y: visible;
  overflow-x: visible;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    padding: 0;
    margin: 0 0 80px 0;
    width: 100%;
  }
`
export const LayoutNarrowTwo = styled(LayoutTwo)`
  grid-template-columns: minmax(150px, 3fr) minmax(700px, 12fr);
`

export const LayoutTwoR = styled.div`
  display: grid;
  grid-template-areas: 'main rightside';
  grid-template-columns: minmax(1000px, 12fr) minmax(90px, 3fr);
  column-gap: 20px;
  row-gap: 25px;
  grid-template-rows: auto;
  width: 1100px;
  margin: 25px auto;
  padding-bottom: 60px;

  overflow-y: visible;
  overflow-x: visible;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    padding: 0;
    margin: 0 0 80px 0;
    width: 100%;
  }
`
export const LayoutTwoScroll = styled(LayoutTwo)`
  overflow-y: hidden;
`

export const LayoutAll = styled.div`
  width: 100%;
`

export const LayoutHome = styled.div`
  display: grid;
  grid-template-areas: 'leftside main';
  grid-template-columns: minmax(250px, 3fr) minmax(700px, 12fr);
  column-gap: 30px;
  row-gap: 25px;
  grid-template-rows: auto;
  width: 1100px;
  margin: 25px auto;
  padding-bottom: 60px;

  overflow-y: visible;
  overflow-x: visible;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    padding: 0;
    margin: 0 0 80px 0;
    width: 100%;
  }
`

export const Card = styled.div`
  text-align: center;
  overflow: hidden;
  margin-bottom: 8px;
  border-radius: 5px;
  border: 1px solid #e1e2e3;
  transition: box-shadow 83ms;
  position: relative;
  padding: 15px 20px;
  background: white;

  @media (max-width: 768px) {
  }

  //box-shadow: 0 0 0 1px rgb(0 0 0 / 15%), 0 0 0 rgb(0 0 0 / 20%);
`
export const CardTitle = styled.p`
  display: flex;
  font-size: 0.9rem;
  color: rgba(0, 0, 0, 0.7);
  font-weight: 700;
  text-align: left;
`

export const CardDesc = styled.p`
  display: flex;
  font-size: 0.95rem;
  color: #666;
  font-weight: 500;
  text-align: left;
`

export const CardContent = styled.div`
  padding-top: 20px;
`
export const ListTitle = styled.div`
  padding-left: 0.2rem;
  padding-bottom: 0.5rem;
  font-size: 1.1rem;
`
export const Lists = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 0.5rem;
`

export const Button = styled.button`
  font-size: 0.97rem;
  min-width: 120px;
  padding: 8px 20px;
  margin-top: 10px;
  border: none;
  background-color: ${(props) => (props.disabled ? 'gray' : 'tomato')};
  color: white;
  margin-right: 10px;
  position: relative;

  &:hover {
    background-color: #4b4b4b44;
  }
  &:active {
    background-color: #0f0f0f44;
  }
`
export const SmallButton = styled(Button)`
  padding: 2px 8px;
  font-size: 0.95rem;
`
export const BlueButton = styled(Button)`
  background-color: ${(props) => (props.disabled ? '#9e9d9d' : 'dodgerblue')};
  &:hover {
    background-color: ${(props) => (props.disabled ? '#9e9d9d' : '#7fbaf5')};
  }
`

export const GrayButton = styled(Button)`
  background-color: ${(props) => (props.disabled ? '#9e9d9d' : 'gray')};
  &:hover {
    background-color: #9e9d9d;
  }
`
export const IndianRedButton = styled(Button)`
  background-color: ${(props) => (props.disabled ? '#9e9d9d' : 'indianred')};
  &:hover {
    background-color: ${(props) => (props.disabled ? '#9e9d9d' : '#ec7575')};
  }
`
export const OrangeButton = styled(Button)`
  background-color: ${(props) => (props.disabled ? '#9e9d9d' : 'orange')};
  &:hover {
    background-color: ${(props) => (props.disabled ? '#9e9d9d' : '#ffc558')};
  }
`
export const TomatoButton = styled(Button)`
  background-color: ${(props) => (props.disabled ? '#9e9d9d' : 'tomato')};
  &:hover {
    background-color: ${(props) => (props.disabled ? '#9e9d9d' : '#fc9481')};
  }
`
export const PurpleButton = styled(Button)`
  background-color: ${(props) => (props.disabled ? '#9e9d9d' : 'purple')};
  &:hover {
    background-color: ${(props) => (props.disabled ? '#9e9d9d' : '#b34db3')};
  }
`
export const GreenButton = styled(Button)`
  background-color: ${(props) => (props.disabled ? '#9e9d9d' : 'green')};
  &:hover {
    background-color: ${(props) => (props.disabled ? '#9e9d9d' : '#439943')};
  }
`
export const NavyButton = styled(Button)`
  background-color: ${(props) => (props.disabled ? '#9e9d9d' : 'navy')};
  &:hover {
    background-color: ${(props) => (props.disabled ? '#9e9d9d' : '#4a4a97')};
  }
`
export const RedButton = styled(Button)`
  background-color: ${(props) => (props.disabled ? '#9e9d9d' : 'red')};
  &:hover {
    background-color: ${(props) => (props.disabled ? '#9e9d9d' : '#ff6a6a')};
  }
`
export const SmallBlueButton = styled(SmallButton)`
  background-color: dodgerblue;
`
export const SmallIndianRedButton = styled(SmallButton)`
  background-color: indianred;
`
export const SmallOrangeButton = styled(SmallButton)`
  background-color: orange;
`
export const SmallTomatoButton = styled(SmallButton)`
  background-color: tomato;
`
export const SmallPurpleButton = styled(SmallButton)`
  background-color: purple;
`
export const SmallNavyButton = styled(SmallButton)`
  background-color: navy;
`
export const SmallRedButton = styled(SmallButton)`
  background-color: red;
`
export const SmallLightGrayButton = styled(SmallButton)`
  background-color: lightgray;
  color: black;
`

export type MaxHeightProps = {
  maxHeight?: string
}

export type SelectedProps = {
  selected?: string
}

export type WidthProps = {
  imageWidth?: number
}

export type IsFullCenterProps = {
  isFullCenter?: boolean
}

export type ExpandedProps = {
  isExpanded: boolean
}

export type ActiveProps = {
  active: boolean
}
